<template>
  <div id="app">

    <transition name="fade" mode="out-in">
    <router-view />
    </transition>
    <Header :key="$route.fullPath" v-if="!$route.path.includes('/admin')"/>

  </div>
</template>
<script>

import Header from './components/Header.vue'
import { firestore, auth, database } from "./main";


export default {
  name: 'app',
  data () {
    return {
      headerColor: "rgba(0, 0, 0, 0.2)",
      activePage: 'LuciDent'
    }
  },
  watch: {
    $route (to, from){
      const page = this.$route.path.split('/')[1]
      this.activePage = page.replace("-", " ")
    }
  },
  components: {
    Header
  },
  methods: {
    setUser: function() {
      this.$store.dispatch("setUser");
    }
  },
  beforeCreate() {
    this.$store.dispatch('fetchCreds');
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    options() {
      return this.$store.state.options;
    }
  }
}

</script>

<style lang="scss">

  $break-small: 900px;
  $brandColor: #29aad0;
  $brandColorTwo: #70c8df;
  $accentColor: #de7c5e;

  @import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro');
  @import url('https://fonts.googleapis.com/css?family=Roboto+Slab&display=swap');

a {
  font-style: unset;
  color: unset;
}
::selection {
  background: rgb(239, 239, 239); /* WebKit/Blink Browsers */
  color: #fff;
}
::-moz-selection {
  background: rgb(239, 239, 239); /* Gecko Browsers */
  color: #fff;
}
.message {
  padding: 2em 0;
}
.page-title {
  color: $brandColor;
  font-size: 18px;
  text-transform: uppercase;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

html,body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-color: rgb(242, 248, 255);

}

.dot {
  background-color: #ddd;
}
.bg-1,.bg-2,.bg-3,.bg-4,.bg-5,.bg-6,.bg-7,.bg-8,.bg-9,.bg-10,.bg-11,.bg-12,.bg-13,.bg-14,.bg-15,.bg-16 {
  background-color: #ddd;
}
.bg-1 {
  background-color: $brandColor;
}
.bg-2 {
  background-color: $accentColor;
}
.bg-3 {
  background-color: $brandColorTwo;
}



#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #222;
  margin-top: 0;
  width: 100%;
  text-align: center;

}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.1s;
  transition-property: opacity;
  transition-timing-function: ease-in-out;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@keyframes animate {
  0% {
    width: 100%;
  }
  50% {
    width: 50%;
  }
  100% {
    width: 100%;
  }
}
  .hide-desktop {
    display: none !important;

  }
  .hide-mobile {
    display: block;
  }

@media only screen and (max-width: 900px) {
  .info {
    width: 90%;
    max-width: 90%;
    margin: 0 auto;
  }
  .info p {
    max-width: 100%;
  }
  .hide-desktop {
    display: block !important;
  }
  .hide-mobile {
    display: none !important;
  }
}


</style>

  





// WEBPACK FOOTER //
// src/App.vue